import React, { useRef, useState, useEffect } from 'react';
import { Form, Button, Card, Alert, Container} from 'react-bootstrap';
import { useAuth } from '../Context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

import logo from '../Assets/logo.png';

export default function EmployeeForgotPassword() {
  const emailRef = useRef();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();
  const navigate = useNavigate();

  useEffect(()=>{
      return () =>{ setLoading(false) }
  }, []);

  async function handleSubmit(event){
    event.preventDefault();
    
    if(emailRef.current.value === null || emailRef.current.value === ''){
        return setError('Email must be filled out');
    }

    try{
        setError('');
        setLoading(true);
        await resetPassword(emailRef.current.value);
        navigate("/employee-reset-notification");
    } catch(error){
        setError('Failed to reset password: ' + error.message);
    }

    setLoading(false);
  }
  return (
    <>
      <Container className="d-flex align-items-center justify-content-center mt-5" style={{minHeight: "60vh"}}>
          <div className="w-100" style={{maxWidth: "600px"}}>
              <Card>
                  <Card.Img variant="top" src={logo} style={{width:"50%", alignSelf:"center", paddingTop:"20px"}}/>
                  <Card.Body>
                      <h2 className="text-center mb-4">Forgot Password</h2>
                      {error && <Alert variant="danger">{error}</Alert>}
                      <Form onSubmit={handleSubmit}>
                          <Form.Group id="email">
                              <Form.Label>Email</Form.Label>
                              <Form.Control type="email" ref={emailRef} required />
                          </Form.Group>
                          <Button disabled={loading}  className="w-100 btn-dark" style={{marginTop: "15px", backgroundColor:"#2596be"}} type="submit" onClick={handleSubmit}>Reset Password</Button>
                      </Form>
                  </Card.Body>
              </Card>
              <div className="w-100 text-center mt-2">
                  Return to <Link to="/employee-login">Log_in</Link>
              </div>
          </div>
      </Container>
    </>
  );
}
